import React from 'react';
import factory from 'components/Icons/factory';

export const Pinterest = factory(
  'Pinterest',
  <path d="M67.1 8C34.5 8 18.1 31.5 18.1 51.1 18.1 62.9 22.6 73.5 32.2 77.4 33.7 78 35.1 77.4 35.6 75.7 35.9 74.5 36.7 71.4 37 70.1 37.4 68.4 37.3 67.8 36 66.3 33.2 63 31.5 58.8 31.5 52.8 31.5 35.3 44.4 19.8 65.3 19.8 83.7 19.8 93.8 31.1 93.8 46.2 93.8 66.1 85 82.8 72 82.8 64.9 82.8 59.5 76.9 61.2 69.5 63.3 60.8 67.3 51.4 67.3 45.1 67.3 39.4 64.3 34.7 58 34.7 50.7 34.7 44.8 42.4 44.8 52.6 44.8 59.1 47 63.5 47 63.5 47 63.5 39.5 95.5 38.2 101 35.5 112.2 37.8 125.9 38 127.2 38.1 128.1 39.1 128.3 39.6 127.6 40.3 126.7 49 115.9 52 105.1 52.8 102 56.8 86.1 56.8 86.1 59.2 90.7 66.2 94.7 73.6 94.7 95.6 94.7 110.6 74.5 110.6 47.5 110.6 27 93.3 8 67.1 8L67.1 8Z" />
);

export default Pinterest;
